module.exports = __webpack_public_path__ + "static/media/invite-friends.d47c3cb8.svg";